<template>
  <layout>
    <page-header :actions="actions">
      <template slot="header">
        <h4 class="mr-4">
          <i class="icon-stack mr-2"></i>
          {{ $t('account.payouts') }}
        </h4>
        <div class="mt-1">
          <span
            v-if="$account && $account.affiliate_commission > 0"
            class="mr-2"
          >
            {{ $t('affiliates.current_commission') }}
            <strong>{{ $account ? $account.affiliate_commission : 0 }}%</strong>
          </span>
          <span v-if="totals.pending" class="mr-2">
            {{ $t('affiliates.pending_amount') }}:
            <strong class="text-success">
              {{ totals.pending | currency(currency) }}
            </strong>
          </span>
          <span v-if="totals.complete" class="mr-2">
            {{ $t('affiliates.complete_amount') }}:
            <strong>{{ totals.complete | currency(currency) }}</strong>
          </span>
        </div>
      </template>
    </page-header>
    <div class="content">
      <admin-table ref="table" v-bind="tableProps" @api-result="onApiResult">
        <template slot="order.amount" slot-scope="{ item }">
          <order-amount :order="item.order" />
        </template>
        <template slot="order.amount_refunded" slot-scope="{ item }">
          {{ item.order.amount_refunded | currency(item.currency_label) }}
        </template>
        <template slot="payout_amount" slot-scope="{ item }">
          {{ item.payout_amount | currency(item.currency_label) }}
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import PayoutsApi from './PayoutsApi'
import OrderAmount from '../../../console/src/orders/OrderAmount'

export default {
  name: 'Payouts',

  components: {
    OrderAmount,
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: 'payouts',
        apiBuilder: () => {
          return new PayoutsApi().setParameters({
            include: 'order',
          })
        },
        columns: [
          {
            key: 'order.invoice_number',
            label: this.$t('orders.number'),
            formatter: value => `#${value}`,
          },
          {
            key: 'order.description',
            label: this.$t('orders.description'),
          },
          {
            key: 'order.amount',
            label: this.$t('orders.order_amount'),
          },
          {
            key: 'order.amount_refunded',
            label: this.$t('orders.amount_refunded'),
          },
          {
            key: 'commission',
            label: this.$t('affiliates.commission'),
            formatter: value => (value ? `${value}%` : null),
          },
          {
            key: 'status_label',
            label: this.$t('general.status'),
          },
          {
            key: 'payout_amount',
            label: this.$t('affiliates.payout_amount'),
          },
        ],

        rowActions: () => [],

        bulkActions: () => {
          return [
            {
              label: this.$t('affiliates.get_a_commission'),
              handler: selected => {
                this.generateInvoice(selected)
              },
            },
          ]
        },
      },
      user: null,
      currency: '',
      totals: {},
    }
  },

  computed: {
    // Page header actions
    actions() {
      if (!this.totals.pending) {
        return []
      }

      return [
        {
          id: 'create',
          text: this.$t('affiliates.get_a_commission'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.generateInvoice()
          },
        },
      ]
    },
  },

  created() {
    const { affiliate } = this.$account
    if (!affiliate) this.$router.replace('/')
  },

  methods: {
    onApiResult(result) {
      this.currency = result.currency_label
      this.totals = result.totals
    },
    async generateInvoice(ids) {
      const { value } = await this.$alert.question(
        this.$t('affiliates.get_commission_confirm'),
        '',
        {
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel'),
          confirmButtonText: this.$t('general.yes'),
        },
      )

      if (value) {
        new PayoutsApi()
          .removeParameter('user_id')
          .process(ids)
          .then(result => {
            this.$toast.success(result.message)
            this.$refs.table.refresh()
          })
          .catch(result => {
            this.$toast.error(result.data.message)
          })
      }
    },
  },
}
</script>
